export default "__VITE_ASSET__Be4PQtei__"